<template>
    <div class="product-add mt30">
      <!--form表单-->
      <el-form size="small" ref="form" :rules="rules" :model="form" label-width="200px">
        <el-form-item label="是否开启推三反一">

         <el-radio-group  v-model="form.status">

             <el-radio :label="0">关闭</el-radio>
             <el-radio  :label="1">开启</el-radio>
         </el-radio-group>

     </el-form-item>

        <el-form-item label="活动名称" prop="name" v-if="form.status == 1">

            <el-input v-model="form.name" type="text" class="max-w460" placeholder="例：推三反一"></el-input>

        </el-form-item>

        <el-form-item label="活动图片">
          <el-row>
            <el-button icon="el-icon-upload" @click="openUpload">选择图片</el-button>
            <div v-if="form.image_id > 0" class="img mt10"><img :src="form.file_path" width="100" height="100" /></div>
          </el-row>
          <div class="gray">图片为2M以内大小，格式限png，jpg格式</div>
        </el-form-item>


        <!-- <el-form-item label="第一次购买返佣" prop="one_commison" v-if="form.one_commison">
            <el-input v-model="form.one_commison" auto-complete="off" type="number"  class="max-w460" placeholder="请输入第一次购买返佣"></el-input>
        </el-form-item>

        <el-form-item label="第二次购买返佣" prop="two_commison" v-if="form.two_commison">
            <el-input v-model="form.two_commison" auto-complete="off" type="number"  class="max-w460" placeholder="请输入第一次购买返佣"></el-input>
        </el-form-item>

        <el-form-item label="第三次购买返佣" prop="three_commison" v-if="form.three_commison">
            <el-input v-model="form.three_commison" auto-complete="off" type="number"  class="max-w460" placeholder="请输入第一次购买返佣"></el-input>
        </el-form-item> -->

        <!-- 第一次购买返佣 -->
<el-form-item label="第一次购买返佣" prop="one_commison">
  <!-- 1. 修正autocomplete拼写 2. 保留type="number" 3. 优化占位符 4. 去掉不合理的v-if，若需控制显示可替换为开关变量 -->
  <el-input
    v-model="form.one_commison"
    autocomplete="off"
    type="number"
    class="max-w460"
    placeholder="请输入第一次购买返佣"
    step="5"
    min="0"
  ></el-input>
</el-form-item>

<!-- 第二次购买返佣 -->
<el-form-item label="第二次购买返佣" prop="two_commison">
  <el-input
    v-model="form.two_commison"
    autocomplete="off"
    type="number"
    class="max-w460"
    placeholder="请输入第二次购买返佣"
    step="5"
    min="0"
  ></el-input>
</el-form-item>

<!-- 第三次购买返佣 -->
<el-form-item label="第三次购买返佣" prop="three_commison">
  <el-input
    v-model="form.three_commison"
    autocomplete="off"
    type="number"
    class="max-w460"
    placeholder="请输入第三次购买返佣"
    step="5"
    min="0"
  ></el-input>
</el-form-item>


        <!-- <el-form-item label="推单次数" prop="num" v-if="form.status == 1">
            <el-input v-model="form.num" auto-complete="off" type="number"  class="max-w460" placeholder="请输入推单次数"></el-input>
        </el-form-item>


        <el-form-item label="满单返利"  prop="money" v-if="form.status == 1">
            <el-input v-model="form.money" auto-complete="off" type="number"  class="max-w460" placeholder="请输入满单返利金额"></el-input>
        </el-form-item>


        <el-form-item label="每单返利"  prop="one_money" v-if="form.status == 1">
          <el-input v-model="form.one_money" auto-complete="off" type="number"  class="max-w460" placeholder="请输入每单返利金额"></el-input>
        </el-form-item>

        <el-form-item label="前提"   v-if="form.status == 1">
          <div>购买一单才会生效</div>
        </el-form-item> -->

<!--
        <div class="common-form">满单n+1</div>

        <el-form-item label="满单n+1"  prop="n_plus_num" v-if="form.status == 1">
          <el-input v-model="form.n_plus_num" auto-complete="off" type="number"  class="max-w460" placeholder="请输入满单n+1"></el-input>
        </el-form-item>

        <el-form-item label="满单n+1返利"  prop="n_plus_money" v-if="form.status == 1">
          <el-input v-model="form.n_plus_money" auto-complete="off" type="number"  class="max-w460" placeholder="满单n+1返利"></el-input>

          <div>举例：推荐三人购买，活动为满单，此时再推荐人购买该商品，则获得满单n+1返利，如满单n+1设置为1，返利设置为1元，则满单后每推荐成功一次则获取一次返利</div>
        </el-form-item> -->

        <el-form-item label="活动排序"  prop="sort" >
          <el-input v-model="form.sort" auto-complete="off" type="number"  class="max-w460" placeholder="请输入活动排序"></el-input>
        </el-form-item>

        <el-form-item label="参与人数"  prop="numun" >
          <el-input v-model="form.numun" auto-complete="off" type="number"  class="max-w460" placeholder="请输入活动参与人数"></el-input>
        </el-form-item>



           <!--商品设置-->
        <Product @updateProduct="updateProduct" v-if="form.status == 1" :form="form" type="edit"></Product>

        <div class="common-form">活动规则</div>

        <el-form-item label="活动规则">
        <div class="edit_container">
          <Uediter v-model="form.richtext" :text="ueditor.text" :config="ueditor.config" ref="ue"></Uediter>
        </div>
        </el-form-item>
        <!--提交-->
        <div class="common-button-wrapper">
          <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
        </div>
      </el-form>

         <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" :type="type" @returnImgs="returnImgsFunc">上传图片</Upload>

    </div>
  </template>

  <script>
//   import TableApi from '@/api/table_num.js';
  import PushagainstApi from '@/api/pushagainst.js'
  import Uediter from '@/components/UE.vue';
  import Upload from '@/components/file/Upload';
  import M from 'minimatch';
  import Product from './Product.vue';
  export default {
    components:{
        Product,
        Uediter,
        Upload
    },
    data() {
      return {
         /*富文本配置*/
        ueditor: {
          text: '',
          config: {
            initialFrameWidth: 400,
            initialFrameHeight: 500
          }
        },
        /*form表单数据*/
        form: {
            pushagainst_setting_id:"",
            name:"",
            status: 0,//状态0  未开启  1 开启
            num:0,
            money:0,
            tableData:[],
            one_money:0,
            n_plus_num:1,
            n_plus_money:0,
            richtext:"",
            image_id:"",
            file_path:"",
            sort:1,
            numun:0
        },
        /*是否正在加载*/
        loading: false,
          /*验证规则*/
        rules: {
            name: [{ required: true, message: "请输入活动名称", trigger: "blur" }],
            num: [{ required: true, message: "请输入推单次数", trigger: "blur" }],
            money: [{ required: true, message: "请输入满单返利金额", trigger: "blur" }],
            one_money: [{ required: true, message: "请输入每单返利金额", trigger: "blur" }]
        },
        type:1,
        isupload:false,
      };
    },
    created() {
      this.getData()
    },
    methods: {
       /*上传*/
      openUpload(e) {
        this.type = e;
        this.isupload = true;
      },
       /*获取图片*/
      returnImgsFunc(e) {
        if (e != null && e.length > 0) {
          this.form.file_path = e[0].file_path;
          this.form.image_id = e[0].file_id;
        }
        this.isupload = false;
      },
        updateProduct(res){
            console.log("子组件修改",res)
            this.form.tableData = res.tableData;
        },
      /*获取数据*/
      getData() {
        let self = this;
        PushagainstApi.get_setting({}, true)
          .then(data => {
            console.log("data",data.data.product)
            if(data.data){
                data.data.tableData =  data.data.product;
                self.ueditor.text =  data.data.richtext;
                self.form = data.data;
            }

            self.loading=false;
          })
          .catch(error => {});
      },
      /*提交表单*/
      onSubmit() {
        let self = this;
        self.loading = true;
        let params = this.form;
        self.form.richtext = this.$refs.ue.getUEContent();
        this.$refs.form.validate(valid => {
            self.form.product_list = JSON.stringify(self.form.tableData);
          let params = self.form;
            self.loading = false;
            if (valid) {
                PushagainstApi.setting(params, true)
                    .then(data => {
                        self.$message({
                            message: data.msg,
                            type: 'success'
                            });
                        if(data.code == 1){
                          //  self.getData();
                        }

                    });
                return;


            }else{
                self.$message({
                            message: "设置错误",
                            type: 'error'
                            });
            }
      });


      }
    }
  };
  </script>

  <style>
  .tips {
    color: #ccc;
  }
  </style>



// WEBPACK FOOTER //
// src/views/plus/pushagainst/setting.vue